<template>
    <div class="compare-result">
        <div class="compare-result__head">
            <div class="compare-result__head-item">
                <h3>{{$t('dash.period1')}}</h3>
                <div class="compare-result__date">
                    {{compareDate.dateTimeBegin1}} / {{compareDate.dateTimeEnd1}}
                </div>
            </div>
            <div class="compare-result__head-item">
                <h3>{{$t('dash.period2')}}</h3>
                <div class="compare-result__date">
                    {{compareDate.dateTimeBegin2}} / {{compareDate.dateTimeEnd2}}
                </div>
            </div>
        </div>
        <div class="compare-result__body">
            <div v-for="item in fields" :key="item.id" class="compare-result__row">
                <CompareItem :item="item"/>
            </div>
        </div>

    </div>
</template>

<script>
    import CompareItem from "./CompareItem";
    export default {
        name: "CompareResult",
        components: {CompareItem},
        props: ['fields', 'compareDate']
    }
</script>
